<template>
  <v-row no-gutters>
    <feature-card-basic ref="featureCard" :layer="layer" @update:feature="onFeatureUpdate">
      <template #top v-if="isMeasurementsVisible">
        <scada-three-measurements
          class="mt-5 pr-8"
          :data-source="currentDataSourceName"
          :feature-id="currentFeatureId"
        />
      </template>
    </feature-card-basic>
  </v-row>
</template>

<script>
import { get } from 'vuex-pathify';

import FeatureCardBasic from '@/components/FeatureCardBasic';
import ScadaThreeMeasurements from '@/components/ScadaThreeMeasurements';

export default {
  name: 'FeatureCardScadaThree',
  components: { FeatureCardBasic, ScadaThreeMeasurements },
  props: {
    layer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isAdminEnabled: get('admin/settingsValues@scada_3_module_enabled'),
    isSuperAdminEnabled: get('admin/additionalModules@SCADA3.enabled'),
    modulesPermissions: get('users/toolsPermissions@SCADA3'),
    dataSources: get('layers/metadata'),
    scadaDataSourceName: get('admin/modulesMapping@scada3.selected_datasource_name'),
    scadaDataSourceAttributes() {
      return this.dataSources?.[this.scadaDataSourceName]?.attributes_schema.attributes || [];
    },
    numericScadaDataSourceAttributes() {
      return this.scadaDataSourceAttributes?.filter(
        attribute => ['integer', 'float', 'decimal'].includes(attribute.data_type.name) && !attribute.read_only
      );
    },
    currentDataSourceName() {
      return this.layer?.data_source_name || '';
    },
    currentFeatureId() {
      return this.$route.params.fid;
    },
    isNew() {
      return this.currentFeatureId === 'new';
    },
    permissions() {
      const value = this.modulesPermissions.main_value;
      return {
        edit: value > 1,
        preview: value > 0,
        value,
      };
    },
    isMeasurementsVisible() {
      return this.isSuperAdminEnabled && this.isAdminEnabled && !this.isNew && this.permissions.preview;
    },
    projectElements: get('layers/project@layers'),
    projectLayers() {
      return this.$_getFlatGroupsLayers(this.projectElements).layers;
    },
  },
  methods: {
    refreshObjectCard() {
      this.$refs.featureCard.updateAfterEdit();
    },
    onFeatureUpdate() {
      this.$root.$emit('refreshTableData');
      this.projectLayers.forEach(layer => {
        if (layer.data_source_name === this.currentDataSourceName) {
          this.$root.$emit('refreshMvtSource', layer.id);
        }
      });
    },
  },
};
</script>
